/* eslint-disable no-unsafe-optional-chaining */
import React from "react";
import SubmittedDetails from "../../../Core/Components/SubmittedDetails";
import UpdatedDetails from "../../../Core/Components/UpdatedDetails";
import ChargerStatus from "../ChargerStatus";
import ListDropdown from "../ListDropdown";
import { getCurrentType } from "../getCurrentType";
import { ITEM_STATUS } from "../../Login/constants";
import RetiredBadge from "../../../Core/Components/RetiredBadge";
import ChargerIcon from "../../../Common/Svgs/ChargerIcon";
import PlugIcon from "../../../Common/Svgs/PlugIcon";
import ServiceIcon from "../../../Common/Svgs/ServiceIcon";

export const chargerColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Serial no.
      </div>
    ),
    dataIndex: "serialNo",
    sorter: (a, b) => a?.serialNo?.localeCompare(b?.serialNo),
    render: (text) => (
      <div>
        <div className="text-xs font-semibold font-aileron leading-4.5 text-black">
          {text}
        </div>
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        KSC Tag no.
      </div>
    ),
    dataIndex: "tagNo",
    sorter: (a, b) => a?.tagNo?.localeCompare(b?.tagNo),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {text}
      </div>
    ),
  },
  // {
  //   title: () => (
  //     <div className="font-normal font-aileron text-10 text-dark-gray">
  //       Thingsboard ID
  //     </div>
  //   ),
  //   dataIndex: "tbId",
  //   render: (text) => (
  //     <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
  //       {text || "--"}
  //     </div>
  //   ),
  // },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Charger Type
      </div>
    ),
    dataIndex: "chargerTypeName",
    sorter: (a, b) => a?.chargerTypeName?.localeCompare(b?.chargerTypeName),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Current
      </div>
    ),
    dataIndex: "currentId",
    sorter: (a, b) => a?.currentId - b?.currentId,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {getCurrentType(parseInt(text, 10))}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Hub Station
      </div>
    ),
    dataIndex: "hubName",
    sorter: (a, b) => a?.hubName?.localeCompare(b?.hubName),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Status
      </div>
    ),
    dataIndex: "status",
    render: (text, record) => {
      if (record.isActive === ITEM_STATUS.RETIRED) return <RetiredBadge />;
      return <ChargerStatus status={text} />;
    },
  },
  {
    title: () => (
      <div className="font-light font-poppins text-10 text-dark-gray">
        Date of Entry
      </div>
    ),
    sorter: (a, b) => a?.submittedAt?.localeCompare(b?.submittedAt),
    dataIndex: "submittedAt",
    width: "200px",
    render: (text, record) => <SubmittedDetails record={record} />,
  },
  {
    title: () => (
      <div className="font-light font-poppins text-10 text-dark-gray">
        Last Updated on
      </div>
    ),
    sorter: (a, b) => (a?.updatedAt || "").localeCompare(b?.updatedAt || ""),
    dataIndex: "updatedAt",
    width: "200px",
    render: (text, record) => <UpdatedDetails record={record} />,
  },
  {
    dataIndex: "id",
    width: "5%",
    render: (text, record) => (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="invisible group-hover:visible w-full flex items-center justify-center"
      >
        <ListDropdown detail={record} />
      </button>
    ),
  },
];

export const KpiData = (data) => {
  return [
    {
      id: 1,
      title: "Total No. Of Chargers",
      image: <ChargerIcon size={16} className="text-kpi-icon" />,
      count: data?.total || 0,
      redirect: false,
    },
    {
      id: 2,
      title: "No. Of Chargers Active",
      image: <PlugIcon size={16} className="text-kpi-icon" />,
      count: data?.active || 0,
      total: data?.total || 0,
      redirect: false,
    },
    {
      id: 3,
      title: "No. Of Chargers In Service",
      image: <ServiceIcon className="w-4 h-4 fill-none stroke-kpi-icon" />,
      count: data?.service || 0,
      redirect: true,
      icon: (
        <img
          src="/assets/icons/chevron-down.svg"
          className="-rotate-90 "
          alt="maintainance"
        />
      ),
    },
  ];
};
